import columns from '../../../../../react-table/helpers/columns';
import { sumTotal, totalRowRatio } from '../../../../../react-table/helpers/rowTotals';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getDetailsTabNavigationProps = type => rowInfo => (rowInfo && rowInfo.row ? {
  reportId: ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_DETAILS.id,
  mainReportId: ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_SUMMARY.id,
  requestParams: {
    originImpc: rowInfo.row['origin.impc'],
    destinationImpc: rowInfo.row['destination.impc'],
    mailCategory: rowInfo.row['despatch.mailCategory'],
    mailClass: rowInfo.original.despatch.mailClassWithSubClass,
    drilldownColumn: type,
  },
  selectionCriteriaOptions: {
    includeSelectionCriteria: true,
  },
} : {});

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    NavigationWithFooterMultipleDrilldownOptionColumn,
  } = columns(data);

  return [
    {
      Header: 'PREDES',
      columns: [
        new TextColumn('Sender', 'predes.sender'),
        new TextColumn('Receiver', 'predes.receiver'),
        new TextColumn('Sending mailbox', 'predes.sendingMailbox'),
        new TextColumn('Receiving mailbox', 'predes.receivingMailbox'),
      ],
    },
    {
      Header: 'Origin IMPC',
      columns: [
        new TextColumn('Operator', 'origin.operator'),
        new TextColumn('Code', 'origin.impc'),
      ],
    },
    {
      Header: 'Destination IMPC',
      columns: [
        new TextColumn('Operator', 'destination.operator'),
        new TextColumn('Code', 'destination.impc'),
      ],
    },
    {
      Header: 'Despatch',
      columns: [
        new TextColumn('Mail category', 'despatch.mailCategory'),
        new TextColumn('Mail class', 'despatch.mailClass').withTotalHeader('Total'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NavigationWithFooterMultipleDrilldownOptionColumn(new NonZeroNumberColumn('PREDES', 'receptacles.predes').withTotalHeader(sumTotal), getDetailsTabNavigationProps('N')),
        new NavigationWithFooterMultipleDrilldownOptionColumn(new NonZeroNumberColumn('CARDIT', 'receptacles.cardit').withTotalHeader(sumTotal), getDetailsTabNavigationProps('Y')),
        new NavigationWithFooterMultipleDrilldownOptionColumn(new NonZeroNumberColumn('PREDES - CARDIT', 'receptacles.diff').withTotalHeader(sumTotal), getDetailsTabNavigationProps('D')),
        new NonZeroPercentageColumn('CARDIT / PREDES', 'receptacles.pct').withTotalHeader(totalRowRatio(['receptacles.cardit', 'receptacles.predes'])),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_DETAILS.id,
        mainReportId: ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_SUMMARY.id,
        requestParams: {
          isTotal: true,
          originImpc: '*',
          drilldownColumn: '',
          mailClass: '*',
          mailCategory: '*',
          destinationImpc: '*',
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
